/* eslint-disable no-unreachable */
import PropTypes from 'prop-types'

import MarkerClusterer from 'node-js-marker-clusterer'
import LeadPartnerMarker from 'assets/images/marker-orange.png'
import PartnerMarker from 'assets/images/marker.png'
import { cloneDeep } from 'lodash'

const MarkerCluster = props => {
  const { map, google, markers, onClusterClick, onMarkerClick, setRef, currentCluster } = props

  if (map && markers && currentCluster.current == null) {
    const marker = new google.maps.Marker({
      position: {
        lat: markers[0].location.lat,
        lng: markers[0].location.lng
      },
      id: markers[0].id,
      icon: {
        url: markers[0].type === 'lead' ? LeadPartnerMarker : PartnerMarker
      }
    })

    const dots = []
    markers.forEach(m => {
      const currentDot = cloneDeep(marker)
      currentDot.icon.url = m.type === 'lead' ? LeadPartnerMarker : PartnerMarker
      currentDot.position = new google.maps.LatLng(m.location.lat, m.location.lng)
      currentDot.id = m.id
      currentDot.addListener('click', () => onMarkerClick({ entry: currentDot, marker: m }))
      dots.push(currentDot)
    })

    const clusterer = new MarkerClusterer(map, dots, {
      imagePath:
        'https://raw.githubusercontent.com/googlemaps/js-marker-clusterer/gh-pages/images/m',
      zoomOnClick: false,
      maxZoom: 11
    })

    google.maps.event.addListener(clusterer, 'clusterclick', cluster => onClusterClick(cluster))

    setRef(clusterer)
  }
  return null
}

MarkerCluster.propTypes = {
  map: PropTypes.object,
  google: PropTypes.object,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number
      })
    })
  )
}

export default MarkerCluster
